module.exports = __webpack_public_path__ + "img/guillemet-1.svg";